/*
 *统计分析
 * @module components/leftmenu/statistics/statisticsQuery
 * @desc 分段统计和分类统计
 * @author zhaoting
 * @date 2020-08-10
 */
import appConfig from 'appConfig';
import { sortChinese } from '@/utils/stringUtils';
import { getJSONByCode } from '@/api/index';
import Cookies from 'js-cookie';
export default {
  name: 'statisticsQuery',
  data() {
    return {
      accessToken: { accessToken: Cookies.get('accessToken') }, // 上传token鉴权
      spintj: false,
      propertyArr: [], //属性字段统计
      propertyArrCopy: [], //属性字段统计
      tjfsArr: [
        {
          name: '求和',
          value: 'Sum',
        },
        {
          name: '求个数',
          value: 'Count',
        },
        {
          name: '最大值',
          value: 'Max',
        },
        {
          name: '最小值',
          value: 'Min',
        },
        {
          name: '平均值',
          value: 'Average',
        },
      ],
      ljdwArr: [], //量级单位统计
      tjdwArr: [], //统计单位统计
      formValue: {
        countExtent: 'drawArea',
        countType: 'classification', //统计类型
      },
      countField: '', //统计字段
      countWay: '', //统计方式
      countUnit: '', //统计单位
      orderUnit: '', //量级单位
      modal1: false,
      formValidate: {
        countType: [{ required: true, message: '统计方式必选', trigger: 'change' }],
        countExtent: [{ required: true, message: '请选择统计范围', trigger: 'change' }],
        countField: [{ required: true, type: Array, message: '分类字段不能为空', trigger: 'blur' }],
        formItems: [{ required: true, type: Array, message: '不能为空', trigger: 'blur' }],
      },
      formItems: [
        {
          countWay: 'Sum', //统计方式
          countField: '', //统计字段
          outStatisticFieldName: '',
        },
      ],
      outStatisticField: [],
      selectFi: '',
      submitLoading: false, // 查询状态
      gridDrawLayer: null,
      gridDraws: null,
      drawGrid: {
        geometry: '',
        polygonWKT: '',
        feature: null,
      },
      analysisData: [],
      myChart1: {},
      myChart2: {},
      myChart3: {},
      fieldHistogramX: [],
      fieldHistogramY: [],
      pieDate: [],
      columns_table: [
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '值',
          key: 'value',
        },
      ],
      tjdata: [],
      totalData: {},
      currentGeometryType: 'esriGeometryPolygon',
      xbootConfig: '',
      xbootshpConfig: '',
      proviceDataList: [],
      selectAreaForm: [],
      subsectionValueArr: [{ valueOne: '', valueTwo: '' }],
      selectAreaArr: [], // 选择的xzqh的数据
      fileId: '',
      shpGeometryWkt: '',
      shpGeojsonStr: '',
      layerDataObj: {}
    };
  },
  components: {},
  computed: {},
  props: {},
  watch: {},
  mounted() {},
  created() {
    this.xbootConfig = this.publicMethod.xbootConfig;
    this.xbootshpConfig = this.publicMethod.baseXbootShp;
    var layerDataObj = window.g.queryAndStaticLayer
    this.layerDataObj = layerDataObj
    this.selLayer(layerDataObj);
    // 获取行政区划的数据
    this.proviceDataList = window.localStorage.getItem('xzqhCode')
      ? JSON.parse(window.localStorage.getItem('xzqhCode'))
      : [];
  },
  methods: {
    /*绘制点线面 */
    drawArea(type) {
      this.fileId = '';
      let that = this;
      if (type == 'delete' && this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDrawLayer.getSource().clear();
        this.drawGrid.geometry = '';
        this.drawGrid.polygonJson = '';
        this.publicMethod.deletdwglayer(this.olmap);
        return;
      }
      switch (type) {
        case 'Circle':
        case 'Box':
        case 'Polygon':
          this.currentGeometryType = 'POLYGON';
          break;
        case 'LineString':
          this.currentGeometryType = 'LINESTRING';
          break;
        case 'Point':
          this.currentGeometryType = 'POINT';
          break;
      }
      this.currentDrawType = type;
      this.initDraw(type);
      this.olmap.addInteraction(this.gridDraws);
      this.gridDrawLayer.getSource().on('addfeature', function(event) {});
      this.gridDraws.on('drawend', function(evt) {
        if (type == 'Circle') {
          that.drawGrid.geometry = that.$olmap.geom.Polygon.fromCircle(
            evt.feature.getGeometry(),
            64
          );
        } else {
          that.drawGrid.geometry = evt.feature.getGeometry();
        }
        that.drawGrid.polygonWKT = new that.$olmap.format.WKT().writeGeometry(
          that.drawGrid.geometry,
          {}
        );
        that.drawGrid.polygonJson = that.drawGrid.geometry.getCoordinates();
        that.olmap.removeInteraction(that.gridDraws);
      });
    },

    //初始化数据源
    initSource(features, geomtry, typeCode) {
      var datasource;
      if (features) {
        //根据上传shp绘制
        datasource = new this.$olmap.source.Vector({
          features: features,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      if (geomtry) {
        //根据上传txt坐标点
        var featuresList = [];
        this.drawGrid.polygonJson = [];
        this.drawGrid.polygonWKT = [];
        for (var item in geomtry) {
          //上传txt存在多面
          var PolygonFeature = new this.$olmap.Feature({
            geometry: geomtry[item],
          });
          // this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          if (typeCode == 'bzb') {
            this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          } else {
            this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0]);
          }
          featuresList.push(PolygonFeature);
          this.drawGrid.polygonWKT.push(
            new this.$olmap.format.WKT().writeGeometry(PolygonFeature.getGeometry(), {})
          ); // geoserver方式
        }
        this.drawGrid.geometry = geomtry[0];
        datasource = new this.$olmap.source.Vector({
          features: featuresList,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      this.initDraw('Polygon', datasource);
    },

    initDraw(type, datasource) {
      this.bufferGeometries = ''; //清空上一次buffer
      //实例化一个矢量图层Vector作为绘制层
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDrawLayer.getSource().clear();
      }
      var result = this.publicMethod.initDrawC(type, datasource);
      this.gridDraws = result.gridDraws;
      this.gridDrawLayer = result.gridDrawLayer;
      this.olmap.addLayer(this.gridDrawLayer);
    },
    //txt上传
    txtBeforupload(file) {
      if (file.type == 'text/plain') {
        var that = this;
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function(oFREvent) {
          //读取完毕从中取值
          var pointsTxt = oFREvent.target.result;
          if (pointsTxt) {
            let result = that.publicMethod.selectTextFile(pointsTxt);
            if(!result){
              that.$Message.info("该数据格式不正确，不支持解析!")
              return;
            }
            result.currentGeometryType = that.currentGeometryType;
            if (result.inputPolygons && result.inputPolygons.length > 0) {
              that.initSource(null, result.inputPolygons, result.typeCode);
            } else {
              that.$Message.warning({
                content: 'txt的坐标文件不正确',
              });
            }
          } else {
            that.$Message.warning({
              content: 'txt的坐标文件不正确',
            });
          }
        };
      } else {
        this.$Message.info('请上传txt文件');
      }
      return false;
    },

    //上传dwg
    dwgBeforupload(file) {
      this.spintj = true;
    },
    dwguploadSuccess2(res, file) {
      //上传成功
      this.spintj = false;
      if (res.code == 200) {
        if (res.result) {
          // dwg数据转为geojson
          var geojsonArr = {
            type: 'FeatureCollection',
            features: [],
          };
          if (res.result.annotation) {
            geojsonArr.features = res.result.annotation;
            this.publicMethod.drawshpanddwg(geojsonArr, 'annotation', this.olmap);
          }
          if (res.result.point) {
            geojsonArr.features = [];
            geojsonArr.features = res.result.point;
            this.publicMethod.drawshpanddwg(geojsonArr, 'point22', this.olmap);
          }

          if (res.result.polyline) {
            geojsonArr.features = [];
            geojsonArr.features = res.result.polyline;
            this.publicMethod.drawshpanddwg(geojsonArr, 'polyline22', this.olmap);
          }
          // 只传面数据
          if (res.result.polygon) {
            geojsonArr.features = [];
            geojsonArr.features = res.result.polygon;
            this.publicMethod.drawshpanddwg(geojsonArr, 'polygon22', this.olmap);
          } else {
            geojsonArr.features = [];
          }
          var result = this.publicMethod.initJson(geojsonArr, this.olmap); //通用shp/dwg转换方法
          this.commonDataGrid(result, 'dwg');
        } else {
          this.$Message.info(res.message ? res.message : '操作失败');
        }
      } else {
        this.$Message.info(res.message ? res.message : '操作失败');
      }
    },
    uploadError(error, file) {
      //上传失败
      this.spintj = false;
      this.$Message.info(error);
    },
    handleFormatError(file) {
      this.spintj = false;
      this.$Message.info('文件格式不正确，请上传*.dwg格式文件');
    },
    //shp上传
    shpBeforupload(file) {
      if (file.name.indexOf('.shp') == -1) {
        this.$Message.info('请上传shp文件');
      } else {
        var that = this;
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = function() {
          let shapefile = require('shapefile');
          shapefile.read(this.result).then(geoJson => {
            var result = that.publicMethod.initJson(geoJson);
            that.commonDataGrid(result);
          });
        };
      }
    },
    handleSuccess(res, file) {
      if (res.success === true) {
        this.$Message.success('上传文件 ' + file.name + ' 成功');
        this.fileId = res.result.id;
        this.shpGeometryWkt = res.result.geometryWkt;
        this.shpGeojsonStr = res.result.geojsonStr;
      } else {
        this.$Message.warning(res.message);
      }
    },

    commonDataGrid(result, type) {
      this.drawGrid.polygonWKT = result.polygonWKT;
      this.drawGrid.geometry = result.geometry;
      this.drawGrid.polygonJson = result.polygonJson;
      this.currentGeometryType = result.currentGeometryType;
      if (!type || type != 'dwg') {
        this.initSource(result.shpfeatures);
      }
    },
    // 图层选择 获取分类字段和统计字段
    async selLayer(item) {
      this.curLayer = item;
      var param = {
        service: 'WFS',
        version: '2.0.0',
        request: 'DescribeFeatureType',
        typeName: item.layername,
        outputFormat: 'application/json',
      };
      if (item.layername.indexOf(':') != -1) {
        var arr = item.layername.split(':');
      }
      this.propertyArr = [];
      let resData = await this.publicMethod.getPropertyType(`/geoserver/${arr[0]}/ows`, param);
      if (resData) {
        var typeCode = resData.featureTypes[0].properties;
        typeCode.length>0 && typeCode.forEach((item,index) =>{
          item.key = item.name
        })
        this.propertyArr = typeCode;
        this.propertyArrCopy = JSON.parse(JSON.stringify(typeCode));
      }
    },
    // 添加统计条件
    addtj() {
      // 先判断之前的数据是否添加完成
      let that = this;
      var err = false;
      this.formItems.forEach(function(val, i) {
        if (val.countWay == '' || val.countField == '') {
          that.$Message.warning('统计类型请添加完成再新增');
          err = true;
          return;
        }
      });
      if (err) {
        return;
      }
      var tj = {
        countWay: 'Sum', //统计方式
        countField: '', //统计字段
        outStatisticFieldName: '',
      };
      this.formItems.push(tj);
    },
    // 移除统计条件
    removetj(item, index) {
      this.formItems.splice(index, 1);
    },
    // 点击统计的按钮
    async handleSubmit() {
      let that = this;
      var selectData = this.layerDataObj;
      if (!this.countField) {
        //分类字段数据
        this.$Message.info('请选择分类字段！');
        return;
      }
      // 处理分类字段数据参数
      var CqlFilter = '';
      this.outStatisticField = [];
      if (this.drawGrid.polygonJson && this.drawGrid.polygonJson.length > 0) {
        //统计范围数据
        if (this.currentGeometryType == 'POINT') {
          //点
          CqlFilter = `INTERSECTS(the_geom,${this.drawGrid.polygonWKT})`;
        } else if (this.currentGeometryType == 'LINESTRING') {
          //线
          CqlFilter = `INTERSECTS(the_geom,${this.drawGrid.polygonWKT})`;
        } else if (this.currentGeometryType == 'POLYGON') {
          //面
          CqlFilter = `INTERSECTS(the_geom,${this.drawGrid.polygonWKT})`;
        } else if (this.fileId) {
          CqlFilter = `INTERSECTS(the_geom,${this.shpGeometryWkt})`;
        }
      } else {
        //没有json范围的时候取当前容器的可视区域的范围；
        if (this.formValue.countExtent == 'xzqh') {
          //有行政区划的时候
          var areaStr = '';
          if (this.selectAreaForm.length > 0) {
            this.selectAreaArr.forEach((item, index) => {
              var strCodeArr = item.geometry.coordinates[0][0];
              strCodeArr.forEach((itemA, indexA) => {
                areaStr += `${itemA[0]} ${itemA[1]},`;
              });
            });
          }
          areaStr = areaStr.substr(0, areaStr.length - 1);
          CqlFilter = `INTERSECTS(the_geom, POLYGON((${areaStr})))`;
        } else {
          //无行政区划去当前的数据
          var extentObject = this.olmap.getView().calculateExtent(this.olmap.getSize());
          var jsonArr = `POLYGON((${Number(extentObject[0])} ${Number(extentObject[1])},${Number(
            extentObject[2]
          )} ${Number(extentObject[1])},${Number(extentObject[2])} ${Number(
            extentObject[3]
          )},${Number(extentObject[0])} ${Number(extentObject[3])},${Number(
            extentObject[0]
          )} ${Number(extentObject[1])}))`;
          CqlFilter = `INTERSECTS(the_geom,${jsonArr})`;
        }
      }
      // 统计类型条件设置
      if (!this.formItems[0].countWay || !this.formItems[0].countField) {
        this.$Message.warning('统计类型没有填完整，请修改！');
        return;
      }
      var flg = false;
      var arrDataWF = [];
      for (var c = 0; c < this.formItems.length; c++) {
        if (!this.formItems[c].countWay || !this.formItems[c].countField) {
          flg = true;
          break;
        }
        var outway = {
          name: '',
          countField: this.formItems[c].countField,
          countWay: this.formItems[c].countWay,
          value: this.formItems[c].countWay + '_' + this.formItems[c].countField,
        };
        arrDataWF.push(outway);
        if (outway.value) {
          outway.name = this.getChineseName(outway.value);
        }
        this.outStatisticField.push(outway);
      }
      if (flg) {
        this.$Message.warning('统计类型没有填完整，请修改！');
        return;
      }
      this.analysisData = [];
      this.totalData = {};
      if (!this.curLayer.tableName) {
        // 处理分类的数据 geoserver 查询
        if (this.formValue.countType == 'subsection') {
          //分类
          var subsectionValuStr = '';
          this.subsectionValueArr.length > 0 &&
            this.subsectionValueArr.forEach(item => {
              if (Number(this.valueOne) > Number(item.valueTwo)) {
                subsectionValuStr += `(${this.countField} >= ${item.valueTwo} and ${this.countField} <= ${item.valueOne}) or `;
              } else {
                subsectionValuStr += `(${this.countField} >= ${item.valueOne} and ${this.countField} <= ${item.valueTwo}) or `;
              }
            });
          subsectionValuStr = subsectionValuStr.substr(0, subsectionValuStr.length - 4);
          CqlFilter = `${CqlFilter} and (${subsectionValuStr})`;
        }
        //无数据库表名时
        var url = `${selectData[0].url}?service=wfs&request=getfeature&typename=${selectData[0].layername}&srsname=${appConfig.map.proj}&outputformat=application/json&version=1.0.0&startIndex=0&maxFeatures=100000000`;
        var params = {
          classificationField: this.countField, //分类字段
          statType: arrDataWF[0].countWay, //统计类型
          statColumn: arrDataWF[0].countField, //统计字段
          url: url, //url地址
          cql_filter: CqlFilter,
          typeName: `${selectData[0].layername.split(':')[1]}`,
          catalog: `${selectData[0].layername.split(':')[0]}`,
        };
        $.ajax({
          type: 'post',
          url: '/zituSpace/layer/geoserverStatService',
          dataType: 'json',
          contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
          data: params,
          success: function(res) {
            that.submitLoading = false;
            that.modal1 = true;
            if (res.code == 200 && res.success) {
              var arrCode = res.result.sum;
              arrCode.forEach((item, index) => {
                var postData = {};
                postData[that.countField] = item.title;
                postData[that.outStatisticField[0].value] = item.value;
                that.analysisData.push({
                  attributes: postData,
                });
              });
              that.totalData.fields = [];
              that.totalData.fields.push({
                alias: that.countField,
                name: that.countField,
                type: 'esriFieldTypeString',
              });
              that.outStatisticField.forEach((item, index) => {
                that.totalData.fields.push({
                  alias: item.value,
                  name: item.value,
                  type: 'esriFieldTypeString',
                });
              });
              var finame = that.outStatisticField[0].value;
              that.selectFi = finame;
              if (finame) {
                var title = that.getChineseName(finame);
              }
              that.spintj = false;
              that.initCountData(finame);
              that.barInit22(title);
              that.pieInit(title);
              that.lineInit(title);
            } else {
              that.totalData.fields = [];
              that.analysisData = [];
            }
          },
          error: function(e) {
            that.submitLoading = false;
          },
        });
      } else {
        //统计类型
        let statType = '';
        switch (arrDataWF[0].countWay) {
          case 'Sum':
            statType = '1';
            break;
          case 'Count':
            statType = '2';
            break;
          case 'Max':
            statType = '3';
            break;
          case 'Min':
            statType = '4';
            break;
          case 'Average':
            statType = '5';
            break;
        }
        if (this.drawGrid.polygonJson && this.drawGrid.polygonJson.length > 0) {
          //统计范围数据
          var rings = that.drawGrid.polygonJson;
          var coordinates = [];
          coordinates.push(rings);
        } else {
          var extentObject = this.olmap.getView().calculateExtent(this.olmap.getSize());
          var jsonArr = `[[${Number(extentObject[0])},${Number(extentObject[1])}],[${Number(
            extentObject[2]
          )},${Number(extentObject[1])}],[${Number(extentObject[2])},${Number(
            extentObject[3]
          )}],[${Number(extentObject[0])},${Number(extentObject[3])}],[${Number(
            extentObject[0]
          )},${Number(extentObject[1])}]]`;
          var coordinates = [[JSON.parse(jsonArr)]];
        }
        let geometriesParams = {
          type: 'MultiPolygon',
          coordinates: coordinates,
        };
        // 处理分段数据
        var fd = [];
        if (this.formValue.countType == 'classification') {
          this.subsectionValueArr = [{ valueOne: '', valueTwo: '' }];
        } else {
          this.subsectionValueArr.length > 0 &&
            this.subsectionValueArr.forEach(item => {
              fd.push([item.valueOne, item.valueTwo]);
            });
        }
        var params = {
          sr:
            appConfig.map.proj && appConfig.map.proj.indexOf(':') != -1
              ? appConfig.map.proj.split(':')[1]
              : '',
          type: statType, //统计类型
          statMode: this.formValue.countType, //统计方式
          classificationField: this.countField, //分类字段
          statisticalFields: arrDataWF[0].countField, //统计字段
          indicate: this.curLayer.tableName,
          fd: fd.length > 0 ? JSON.stringify(fd) : '', //分段的数据
          geometriesParams: JSON.stringify(geometriesParams),
          fileId: this.fileId,
        };
        $.ajax({
          type: 'post',
          url: '/zituSpace/tourismInfo/getGeoserverStatistics',
          contentType: 'application/json; charset=UTF-8',
          data: JSON.stringify(params),
          success: function(res) {
            that.submitLoading = false;
            that.modal1 = true;
            if (res.code == 200 && res.success) {
              var number = 0;
              var arrCode = res.result.sum;
              arrCode.forEach((item, index) => {
                var postData = {};
                postData[that.countField] = item.title;
                postData[that.outStatisticField[0].value] = item.value;
                that.analysisData.push({
                  attributes: postData,
                });
              });
              that.totalData.fields = [];
              that.totalData.fields.push({
                alias: that.countField,
                name: that.countField,
                type: 'esriFieldTypeString',
              });
              that.outStatisticField.forEach((item, index) => {
                that.totalData.fields.push({
                  alias: item.value,
                  name: item.value,
                  type: 'esriFieldTypeString',
                });
              });
              var finame = that.outStatisticField[0].value;
              that.selectFi = finame;
              if (finame) {
                var title = that.getChineseName(finame);
              }
              that.spintj = false;
              that.initCountData(finame);
              that.barInit22(title);
              that.pieInit(title);
              that.lineInit(title);
            } else {
              that.totalData.fields = [];
              that.analysisData = [];
            }
          },
          error: function(e) {
            that.submitLoading = false;
          },
        });
      }
    },

    handleReset() {
      this.fileId = '';
      this.formValue.countType = 'classification';
      this.formItems = [
        {
          countWay: 'Sum', //统计方式
          countField: '', //统计字段
          outStatisticFieldName: '',
        },
      ];
      this.countField = '';
      this.countWay = '';
      this.countUnit = '';
      this.orderUnit = '';
      this.gridDrawLayer.getSource().clear();
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDraws = null;
      }
      this.drawGrid = {
        geometry: '',
        polygonWKT: '',
        feature: null,
      };
      this.$bus.emit('closebottom', null);
    },
    tabtest(name) {
      // tab页切换
      if (name == '柱状图') {
        this.myChart1.resize();
      } else if (name == '饼状图') {
        that.myChart2.resize();
      } else if (name == '折线图') {
        that.myChart3.resize();
      } else if (name == '统计表') {
      }
    },

    /**
     * @author zt
     * @description 柱状图初始化
     * @param {Object} arr1
     */
    barInit22(FieldName) {
      var that = this;
      var dom1 = $('.modelcontent .chart_container1')[0];
      dom1.style.width = '91%';
      this.myChart1 = echarts.init(dom1);
      var optionChart1 = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [FieldName],
        },
        toolbox: {},
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: this.fieldHistogramX,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: FieldName,
            type: 'bar',
            data: this.fieldHistogramY,
            itemStyle: {
              normal: {
                // barBorderRadius: 20,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0099FA',
                  },
                  {
                    offset: 1,
                    color: '#E7F4FC',
                  },
                ]),
                shadowColor: 'rgba(0, 0, 0, 0.4)',
                // shadowBlur: 20
              },
            },
          },
        ],
      };

      // 柱状图
      // this.myChart1.setOption(this.optionChart1);
      setTimeout(function() {
        that.myChart1.setOption(optionChart1);
        that.myChart1.resize();
      }, 500);
    },

    /**
     * @author zt
     * @description 折线图初始化
     * @param {Object} arr2
     */
    lineInit(FieldName) {
      var that = this;
      var dom2 = $('.modelcontent .chart_container2')[0];
      this.myChart2 = echarts.init(dom2);
      var optionChart2 = {
        //backgroundColor:"",
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [],
        },
        toolbox: {},
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.fieldHistogramX,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: FieldName,
            type: 'line',
            data: this.fieldHistogramY,
            itemStyle: {
              normal: {
                width: 3,
                color: '#0099FA',
              },
            },
          },
        ],
      }; // 折线图
      // this.myChart2.setOption(this.optionChart2);
      setTimeout(function() {
        that.myChart2.setOption(optionChart2);
        that.myChart2.resize();
      }, 500);
    },

    /**
     * @author zt
     * @description 饼图图初始化
     * @param {Object} arr3
     */
    pieInit(name) {
      var that = this;
      var dom3 = $('.modelcontent .chart_container3')[0];
      this.myChart3 = echarts.init(dom3);
      var optionChart3 = {
        title: {
          text: '',
          x: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          data: that.fieldHistogramX,
          type: 'scroll',
        },
        toolbox: {},
        calculable: true,
        series: [
          {
            name: name,
            type: 'pie',
            // radius : '55%',
            radius: ['50%', '70%'],
            label: {
              normal: {
                show: false,
                position: 'center',
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold',
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: that.pieDate,
          },
        ],
      }; // 饼图
      // this.myChart3.setOption(this.optionChart3);

      setTimeout(function() {
        that.myChart3.setOption(optionChart3);
        that.myChart3.resize();
      }, 500);
    },
    // 导出
    exportpic(name) {
      if (name == '柱状图') {
        var mycanvas = $('.chart_container1').find('canvas')[0];
        var name = '柱状图';
      } else if (name == '饼状图') {
        var mycanvas = $('.chart_container3').find('canvas')[0];
        var name = '饼状图';
      } else if (name == '折线图') {
        var mycanvas = $('.chart_container2').find('canvas')[0];
        var name = '折线图';
      } else if (name == '统计表') {
        this.$refs.tabletj.exportCsv({
          filename: '统计结果导出',
        });
        return;
      }

      if (mycanvas) {
        var image = mycanvas.toDataURL('image/png');
        var $a = document.createElement('a');
        $a.setAttribute('href', image);
        $a.setAttribute('download', name);
        $a.click();
      }
    },
    /**
     * @author zt
     * @description 初始化构造数据结构
     */
    initCountData(outStatisticFieldName) {
      var dataTmp = [];
      this.fieldHistogramX = []; //x的值
      this.fieldHistogramY = []; //Y的值
      this.columns_table = [];
      let that = this;
      //add by luxiaolin begin 20210617 饼图重复数据
      this.pieDate = [];
      //add by luxiaolin end
      if (this.totalData.fields && this.totalData.fields.length > 0) {
        this.totalData.fields.forEach(function(field) {
          // 循环propertyArr
          var tit = field.alias;
          var type = field.type;
          for (var i = 0; i < that.propertyArr.length; i++) {
            if (field.name.indexOf(that.propertyArr[i].key) >= 0) {
              // 在判断是否存在计算函数
              if (field.name.indexOf('Sum') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_求和' :that.propertyArr[i].name + '_求和';
              } else if (field.name.indexOf('Count') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_求个数':that.propertyArr[i].name + '_求个数';
              } else if (field.name.indexOf('Max') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_最大值':that.propertyArr[i].name + '_最大值';
              } else if (field.name.indexOf('Min') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_最小值':that.propertyArr[i].name + '_最小值';
              } else if (field.name.indexOf('Avg') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_平均值':that.propertyArr[i].name + '_平均值';
              } else if (field.name.indexOf('Median') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_中位数':that.propertyArr[i].name + '_中位数';
              } else if (field.name.indexOf('StdDev') >= 0) {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_标准差':that.propertyArr[i].name + '_标准差';
              } else {
                tit = that.propertyArr[i].alias?that.propertyArr[i].alias :that.propertyArr[i].name;
              }
              break;
            }
          }
          var col = {
            title: tit,
            key: field.name,
            align: 'center',
          };
          that.columns_table.push(col);
          //先统计总数
          //add by luxiaolin begin 20210519 防止多算两次
          dataTmp = [];
          that.tjdata = [];
          that.pieDate = [];
          that.fieldHistogramX = [];
          that.fieldHistogramY = [];
          //add by luxiaolin end
          if (null != that.analysisData && that.analysisData.length > 0) {
            for (var d = 0; d < that.analysisData.length; d++) {
              // 判断是否是日期类型
              var val1 = that.analysisData[d].attributes[that.countField];
              if (that.countField == field.name && type == 'esriFieldTypeDate') {
                val1 = that.getdatachange(that.analysisData[d].attributes[that.countField]);
                that.analysisData[d].attributes[that.countField] = val1;
              }
              that.fieldHistogramX.push(val1); //图例，x轴
              // 判断是否是日期类型
              var val2 = that.analysisData[d].attributes[outStatisticFieldName];
              if (outStatisticFieldName == field.name && type == 'esriFieldTypeDate') {
                val2 = that.getdatachange(that.analysisData[d].attributes[outStatisticFieldName]);
                that.analysisData[d].attributes[outStatisticFieldName] = val2;
              }
              that.fieldHistogramY.push(val2);
              var tmp = {
                name: val1,
                value: val2,
              };
              that.pieDate.push(tmp);
              that.tjdata.push(that.analysisData[d].attributes);
            }
          }
          /**
           * add by luxiaolin begin 20210617 统计图按字母排序
           */
          if (null != that.fieldHistogramX && that.fieldHistogramX.length > 0) {
            for (var n = 0; n < that.fieldHistogramX.length; n++) {
              var mHistogram = { name: that.fieldHistogramX[n], value: that.fieldHistogramY[n] };
              dataTmp.push(mHistogram);
            }
          }
          sortChinese(dataTmp, 'name');
          sortChinese(that.pieDate, 'name');
          sortChinese(that.tjdata, 'dlmc');
          if (null != dataTmp && dataTmp.length > 0) {
            that.fieldHistogramX = [];
            that.fieldHistogramY = [];
            for (var j = 0; j < dataTmp.length; j++) {
              that.fieldHistogramX.push(dataTmp[j]['name']);
              that.fieldHistogramY.push(dataTmp[j]['value']);
            }
          }
          /**
           * add by luxiaolin end
           */
        });
      }
    },
    /**
     * @author zt
     * @description 初始化构造数据结构
     */
    initStatisicData() {
      var dataTmp = [];
      if (null != this.analysisData && this.analysisData.length > 0) {
        for (var i = 0; i < this.analysisData.length; i++) {
          if ('面积' == this.countWay) {
            if (null != dataTmp && dataTmp.length > 0) {
              var count = 0;
              for (var m = 0; m < dataTmp.length; m++) {
                if (dataTmp[m].name == this.analysisData[i].attributes[this.countField]) {
                  count++;
                  dataTmp[m].value = dataTmp[m].value + this.analysisData[i].attributes.Shape_Area;
                }
              }
              if (0 == count) {
                var fieldH = {
                  name: this.analysisData[i].attributes[this.countField],
                  value: this.analysisData[i].attributes.Shape_Area,
                };
                dataTmp.push(fieldH);
              }
            } else {
              var fieldH = {
                name: this.analysisData[i].attributes[this.countField],
                value: this.analysisData[i].attributes.Shape_Area,
              };
              dataTmp.push(fieldH);
            }
          } else if ('个数' == this.countWay) {
            if (null != dataTmp && dataTmp.length > 0) {
              var count = 0;
              for (var m = 0; m < dataTmp.length; m++) {
                if (dataTmp[m].name == this.analysisData[i].attributes[this.countField]) {
                  count++;
                  dataTmp[m].value = dataTmp[m].value + 1;
                }
              }
              if (0 == count) {
                var fieldH = {
                  name: this.analysisData[i].attributes[this.countField],
                  value: 1,
                };
                dataTmp.push(fieldH);
              }
            } else {
              var fieldH = {
                name: this.analysisData[i].attributes[this.countField],
                value: 1,
              };
              dataTmp.push(fieldH);
            }
          } else if ('最大值' == this.countWay) {
            if (null != dataTmp && dataTmp.length > 0) {
              var count = 0;
              for (var m = 0; m < dataTmp.length; m++) {
                if (dataTmp[m].name == this.analysisData[i].attributes[this.countField]) {
                  count++;
                  if (dataTmp[m].value < this.analysisData[i].attributes.Shape_Area)
                    dataTmp[m].value = this.analysisData[i].attributes.Shape_Area;
                }
              }
              if (0 == count) {
                var fieldH = {
                  name: this.analysisData[i].attributes[this.countField],
                  value: this.analysisData[i].attributes.Shape_Area,
                };
                dataTmp.push(fieldH);
              }
            } else {
              var fieldH = {
                name: this.analysisData[i].attributes[this.countField],
                value: this.analysisData[i].attributes.Shape_Area,
              };
              dataTmp.push(fieldH);
            }
          } else if ('最小值' == this.countWay) {
            if (null != dataTmp && dataTmp.length > 0) {
              var count = 0;
              for (var m = 0; m < dataTmp.length; m++) {
                if (dataTmp[m].name == this.analysisData[i].attributes[this.countField]) {
                  count++;
                  if (dataTmp[m].value > this.analysisData[i].attributes.Shape_Area)
                    dataTmp[m].value = this.analysisData[i].attributes.Shape_Area;
                }
              }
              if (0 == count) {
                var fieldH = {
                  name: this.analysisData[i].attributes[this.countField],
                  value: this.analysisData[i].attributes.Shape_Area,
                };
                dataTmp.push(fieldH);
              }
            } else {
              var fieldH = {
                name: this.analysisData[i].attributes[this.countField],
                value: this.analysisData[i].attributes.Shape_Area,
              };
              dataTmp.push(fieldH);
            }
          } else if ('长度' == this.countWay) {
            if (null != dataTmp && dataTmp.length > 0) {
              var count = 0;
              for (var m = 0; m < dataTmp.length; m++) {
                if (dataTmp[m].name == this.analysisData[i].attributes[this.countField]) {
                  count++;
                  dataTmp[m].value = dataTmp[m].value + this.analysisData[i].attributes.Shape_Leng;
                }
              }
              if (0 == count) {
                var fieldH = {
                  name: this.analysisData[i].attributes[this.countField],
                  value: this.analysisData[i].attributes.Shape_Leng,
                };
                dataTmp.push(fieldH);
              }
            } else {
              var fieldH = {
                name: this.analysisData[i].attributes[this.countField],
                value: this.analysisData[i].attributes.Shape_Leng,
              };
              dataTmp.push(fieldH);
            }
          }
        }
      }
      if (null != dataTmp && dataTmp.length > 0) {
        this.pieDate = [];
        for (var n = 0; n < dataTmp.length; n++) {
          this.fieldHistogramX.push(dataTmp[n].name);
          if ('个数' == this.countWay) {
            this.fieldHistogramY.push(dataTmp[n].value);
            var tmp = {
              name: dataTmp[n].name,
              value: dataTmp[n].value,
            };
            this.pieDate.push(tmp);
          } else {
            this.fieldHistogramY.push(dataTmp[n].value.toFixed(2));
            var tmp = {
              name: dataTmp[n].name,
              value: dataTmp[n].value.toFixed(2),
            };
            this.pieDate.push(tmp);
          }
        }
        this.tjdata = this.pieDate;
        //  		this.pieDate = dataTmp;
      }
    },
    selectoutstatistic(name) {
      this.selectFi = name;
      var title = this.getChineseName(name);
      this.initCountData(name);
      this.barInit22(title);
      this.pieInit(title);
      this.lineInit(title);
    },
    /**
     * @author zt
     * 2020 12-31
     * @description 获取别名
     */
    getChineseName(name) {
      let that = this;
      // 循环propertyArr
      var tit = name;
      for (var i = 0; i < that.propertyArr.length; i++) {
        if (name.indexOf(that.propertyArr[i].key) >= 0) {
          // 包含
          if (name.indexOf('Sum') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_求和': that.propertyArr[i].name + '_求和';
          } else if (name.indexOf('Count') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_求个数': that.propertyArr[i].name + '_求个数';
          } else if (name.indexOf('Max') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_最大值': that.propertyArr[i].name + '_最大值';
          } else if (name.indexOf('Min') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_最小值': that.propertyArr[i].name + '_最小值';
          } else if (name.indexOf('Avg') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_平均值': that.propertyArr[i].name + '_平均值';
          } else if (name.indexOf('Median') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_中位数': that.propertyArr[i].name + '_中位数';
          } else if (name.indexOf('StdDev') >= 0) {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias + '_标准差': that.propertyArr[i].name + '_标准差';
          } else {
            tit = that.propertyArr[i].alias?that.propertyArr[i].alias: that.propertyArr[i].name;
          }
          break;
        }
      }
      return tit;
    },
    // 日期格式转化
    getdatachange(data) {
      var timestamp4 = '';
      var date = new Date(data);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate() + ' ';
      timestamp4 = Y + M + D;
      return timestamp4;
    },
    // 选绘制方式的事件
    selectCountExtent(value) {
      if (value == 'drawArea') {
        this.selectAreaArr = [];
        this.selectAreaForm = [];
      } else {
        this.gridDrawLayer.getSource().clear();
        if (this.gridDraws) {
          this.olmap.removeInteraction(this.gridDraws);
          this.gridDraws = null;
        }
        this.drawGrid = {
          geometry: '',
          polygonWKT: '',
          feature: null,
        };
      }
    },
    // 选择行政区划的事件
    selectArea(value) {
      if (value.length > 0) {
        var valueCode = value[value.length - 1];
        this.getJSONArea(valueCode);
      } else {
        this.selectAreaArr = [];
      }
    },
    // 根据行政编号获取json的数据
    getJSONArea(code) {
      var param = {
        areaCode: code,
      };
      getJSONByCode(param).then(res => {
        if (res.code == 200 && res.success) {
          this.selectAreaArr = res.result.cityMap.features;
        }
      });
    },
    // 点击新增分段的按钮
    addSubsection() {
      this.subsectionValueArr.push({
        valueOne: '',
        valueTwo: '',
      });
    },
    // 点击减少分段的按钮
    reduceSubsection(index) {
      this.subsectionValueArr.splice(index, 1);
    },
    // 选择统计方式字段
    selectCountType(value) {
      this.countField = '';
      this.formItems = [
        {
          countWay: 'Sum', //统计方式
          countField: '', //统计字段
          outStatisticFieldName: '',
        },
      ];
      if (value == 'subsection') {
        var newArr = [];
        for (let i = 0; i < this.propertyArr.length; i++) {
          if (this.propertyArr[i].type == 'number' || this.propertyArr[i].type == 'int') {
            newArr.push(this.propertyArr[i]);
          }
        }
        this.propertyArr = JSON.parse(JSON.stringify(newArr));
      } else {
        this.propertyArr = JSON.parse(JSON.stringify(this.propertyArrCopy));
        this.$forceUpdate();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/leftmenu/statistics/statisticsQuery.js